module.exports = __webpack_public_path__ + "img/2025-09-19d_1.d01b2f78.jpg";